module.exports = __webpack_public_path__ + "img/selfcomp.4a77abf3.svg";